/**
 * Modal hiển thị tiến trình tải Model AI vào IndexedDB lần đầu tiên
 * Thiết kế giao diện cao cấp, hiển thị số MB, phần trăm %, tốc độ tải
 */
export class TTSLoadingModal {
  constructor() {
    this.modalEl = null;
    this.progressBarEl = null;
    this.percentTextEl = null;
    this.detailsTextEl = null;
    this.speedTextEl = null;

    this.createDom();
  }

  createDom() {
    // Nếu đã có thì không tạo lại
    if (document.getElementById('tts-loading-modal')) {
      this.modalEl = document.getElementById('tts-loading-modal');
      return;
    }

    const modal = document.createElement('div');
    modal.id = 'tts-loading-modal';
    modal.className = 'tts-loading-modal-overlay';
    modal.style.display = 'none';

    modal.innerHTML = `
      <div class="tts-loading-card">
        <div class="tts-loading-header">
          <div class="tts-loading-icon">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="#1a73e8">
              <path d="M12 3v9.28a4.39 4.39 0 0 0-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"/>
            </svg>
          </div>
          <div>
            <div class="tts-loading-title">Đang đồng bộ tài nguyên hỗ trợ tiếp cận (Screen Reader)</div>
            <div class="tts-loading-subtitle">Tự động lưu vào bộ nhớ đệm trình duyệt để sử dụng mượt mà không tốn mạng</div>
          </div>
        </div>

        <div class="tts-progress-track">
          <div class="tts-progress-bar" id="tts-progress-bar" style="width: 0%;"></div>
        </div>

        <div class="tts-progress-stats">
          <span id="tts-progress-percent" style="font-weight:700;color:#1a73e8;">0%</span>
          <span id="tts-progress-details" style="color:#5f6368;">Đang kết nối...</span>
          <span id="tts-progress-speed" style="color:#137333;font-weight:500;">0 MB/s</span>
        </div>

        <div class="tts-loading-note">
          💡 <b>Thông tin:</b> Dữ liệu được đệm an toàn trực tiếp trên trình duyệt của bạn, hoạt động ổn định và có thể sử dụng ngoại tuyến (Offline).
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    this.modalEl = modal;
    this.progressBarEl = modal.querySelector('#tts-progress-bar');
    this.percentTextEl = modal.querySelector('#tts-progress-percent');
    this.detailsTextEl = modal.querySelector('#tts-progress-details');
    this.speedTextEl = modal.querySelector('#tts-progress-speed');
  }

  /**
   * Mở modal tiến trình tải
   */
  open() {
    if (this.modalEl) {
      this.modalEl.style.display = 'flex';
      this.updateProgress({ loaded: 0, total: 100, percent: 0, speedText: 'Bắt đầu tải...' });
    }
  }

  /**
   * Cập nhật tiến trình tải
   * @param {{ loaded: number, total: number, percent: number, speedText: string }} data
   */
  updateProgress(data) {
    if (!this.modalEl) return;

    const percent = Math.min(100, Math.max(0, data.percent || 0));
    if (this.progressBarEl) this.progressBarEl.style.width = `${percent}%`;
    if (this.percentTextEl) this.percentTextEl.textContent = `${percent}%`;

    const loadedMB = (data.loaded / (1024 * 1024)).toFixed(1);
    const totalMB = (data.total / (1024 * 1024)).toFixed(1);
    if (this.detailsTextEl) this.detailsTextEl.textContent = `${loadedMB} MB / ${totalMB} MB`;
    if (this.speedTextEl) this.speedTextEl.textContent = data.speedText || '';

    // Khi đạt 100%
    if (percent >= 100) {
      if (this.detailsTextEl) this.detailsTextEl.textContent = 'Đã hoàn tất! Đang khởi động...';
      setTimeout(() => this.close(), 1000);
    }
  }

  /**
   * Đóng modal tiến trình tải
   */
  close() {
    if (this.modalEl) {
      this.modalEl.style.display = 'none';
    }
  }
}
